export default "__VITE_ASSET__CTmpxp1D__"